import { Divider, Grid, MenuItem } from "@mui/material";
import { FormikTextField } from "../../../components/Layout/FormikTextField";
import { CountriesList } from "../types/processTypes";
import { useTranslation } from "react-i18next";

export const ContactPerson = () => {
  const { t } = useTranslation();
  const { t: te } = useTranslation("enums");

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item md={8} xs={12}>
          <FormikTextField formikKey="contactPerson.displayName" label="Name" />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField formikKey="contactPerson.kinship" label="Kinship" />
        </Grid>
      </Grid>
      <Divider variant="fullWidth" textAlign="left" sx={{ mt: 1 }}>
        Address
      </Divider>
      <Grid container spacing={2}>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="contactPerson.address.telephone"
            label={t("telephone")}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="contactPerson.address.alternateTelephone"
            label={t("alternateTelephone")}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="contactPerson.address.city"
            label={t("city")}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="contactPerson.address.streetAddress"
            label={t("address")}
          />
        </Grid>
        <Grid item md={4} xs={12}>
          <FormikTextField
            formikKey="contactPerson.address.country"
            select
            label={t("country")}
          >
            {Object.keys(CountriesList).map((option) => (
              <MenuItem key={option} value={option as string}>
                {te((option as string).toLowerCase())}
              </MenuItem>
            ))}
          </FormikTextField>
        </Grid>
      </Grid>
    </div>
  );
};
